import { createUseStyles } from "react-jss";
import { theme } from "$utils/theme/bataillog";

const useStyles = createUseStyles(() => ({
  tableContainer: {
    "& thead": {
      display: "none",
    },
    "& table": {
      borderSpacing: `0 ${theme.spacing(2)}px`,
      borderCollapse: "separate",
    },
    "& td": {
      borderTop: `1px solid ${theme.color.gray2}`,
      "&:first-child": {
        borderLeft: `1px solid ${theme.color.gray2}`,
      },
      "&:last-child": {
        borderRight: `1px solid ${theme.color.gray2}`,
      },
    },
    "& [class*='ellipsis']": {
      width: "100%",
    },
  },
  productDesignation: {
    marginBottom: theme.spacing(1),
    display: "block",
  },
  popin: {
    display: "flex",
    flexDirection: "column",
    maxWidth: "50%",
  },
  CircularProgress: {
    flex: 1,
    height: "50vh",
    display: "flex",
    justifyContent: "center",
    backgroundColor: "white",
    alignItems: "center",
    paddingBottom: "calc(var(--fullVh) - 50px)",
  },
}));

export default useStyles;
